import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import ACdetails from "./ACdetails";
import OrgDetails from "./OrgDetails";
import ShippingAddressFile from "./ShippingAddressFile";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import SitesSurvery from "./SitesSurvery";
import Extramaterial from "./Extramaterial";
import LoadingAnimation from "../LoadingAnimation";
import ShippingAddressGuid from "./ShippingAddressguid";
import { useParams } from "react-router-dom";
import Acountant from "./Acountant";
import ACpricingConfig from "./pricingConfig";
import stateWiseACDetails from "./stateWiseACDetails";
import ACpricingConfigDelhi from "./pricingConfigDelhi";
const OrderForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isExisting = location.state?.isExisting;
  const apiMaterials = location.state?.apiMaterials;
  const [take3MonthPayment, setTake3MonthPayment] = useState(
    location.state?.take3MonthPayment || false
  );
  let state = localStorage.getItem("state");
  const { itemId } = useParams(); // Extract itemId from the route parameters
  const [customer, setCustomer] = useState([]);
  const [CustomerData, setCustomerData] = useState();
  const [selectedOrgId, setSelectedOrgId] = useState(null);
  const [selectedOrgData, setSelectedOrgData] = useState(null);
  const [transformedAddress, setTransformedAddress] = useState(null);
  const [selectedShippingAddress, setSelectedShippingAddress] = useState(null);
  const [shippingAddresses, setShippingAddresses] = useState([]);
  const [shippingaddressorder, setShippingAddressorder] = useState();
  const [CustomerIds, setCustomerIds] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [brandName, setBrandName] = useState("");
  const [isSameAsBilling, setIsSameBilling] = useState(false);
  let [savedItems, setSavedItems] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [splitRefundableCharge, setsplitRefundableCharge] = useState(6000); // Default Split AC charge
  const [isAfterCutoff, setIsAfterCutoff] = useState(false);
  // const [acDetails, setACDetails] = useState({
  //   acType: "Split",
  //   ton: "10", // Updated to user-friendly labels
  //   plan: "3+2year",
  //   quantity: 1,
  //   subscription_plan: 1425,
  //   depositamount: 6000,
  //   installetionCharge: 1800,
  //   extraCharge: 349,
  //   itemId: "mc_3y_1.0",
  //   totalSubscription: 1425,
  //   totalDeposit: 6000,
  //   totalInstallation: 1800,
  //   priceAfter3Years: 950,
  //   totalAfter3Years: 950,
  //   totalAmount: 9225,
  // });

  const [acDetails, setACDetails] = useState({
    acType: "",
    ton: "",
    plan: "",
    quantity: 1,
    subscription_plan: 0,
    depositamount: 0,
    installetionCharge: 0,
    extraCharge: 0,
    itemId: "",
    totalSubscription: 0,
    totalDeposit: 0,
    totalInstallation: 0,
    priceAfter3Years: 0,
    totalAfter3Years: 0,
    totalAmount: 0,
  });
  useEffect(() => {
    const currentState = state || "Maharashtra";
    const details =
      stateWiseACDetails[currentState] || stateWiseACDetails["Maharashtra"];
    setACDetails(details);
  }, [state]);
  const [showSavedItems, setShowSavedItems] = useState(false);
  const [shippingAddress, setShippingAddress] = useState({
    line1: "",
    line2: "",
    pincode: "",
    city: "",
    state: "",
  });
  const [copiedShippingAddress, setCopiedShippingAddress] = useState(null);
  const [gstin, setgstin] = useState({
    name: "",
    number: "",
    billingName: "",
    address: "",
    phoneNumber: "", // Added phone number field
    email: "",
  });
  const [searchOrg, setSearchOrg] = useState("");
  const [billingAddress, setBillingAddress] = useState({
    line1: "",
    line2: "",
    pincode: "",
    city: "",
    state: "",
  });
  const [isChecked, SetisChecked] = useState(false);
  const [isExistingCustomer, setIsExistingCustomer] = useState(false);
  const [selectedAddressIndex, setSelectedAddressIndex] = useState(null);
  const [currentMaterial, setCurrentMaterial] = useState({
    materialType: "copper_piping_p",
    quantity: "1",
    price: "384",
    total: "384",
  });
  const [ischecksuperadmin, setchecksuperadmin] = useState(false);
  const [contactInformation, setContactInformation] = useState({
    contactPerson: "",
    contactNumber: "",
  });
  const [accountantInformation, setAccountantInformation] = useState({
    accountantPerson: "",
    accountantNumber: "",
    accountantEmail: "",
  });
  const [selectedcustomeraddress, setselectedcustomeraddress] = useState({});
  const [editmode, seteditmode] = useState(false);
  const [bygstcustomeer, setbygstcustomer] = useState(false);



  let user = localStorage.getItem("userName");
  const editableUsers = [
    "Karishma",
    "Deepak Undariwal",
    "Sales Admin",
    "Noorbi Shaikh",
    "Ashish A (Delhi)",
    "Gajanan Padhar",
    "Vineet Vidyanand",
  ];
  const isEditableUser = editableUsers.includes(user);
  useEffect(() => {
    if (isSameAsBilling && gstin.name) {
      // console.log("gst name", gstin.name)
      setBrandName(gstin.name);
    }
  }, [isSameAsBilling, gstin.name]);

  useEffect(() => {
    if (
      CustomerIds !== null &&
      Object.keys(selectedcustomeraddress).length > 0
    ) {
      const updatedAddress = {
        ...selectedcustomeraddress,
        contactPerson: contactInformation.contactPerson,
        contactNumber: contactInformation.contactNumber,
      };

      axios
        .put(
          `${process.env.REACT_APP_MYBACKEND_PI}/api/customer/customers/${CustomerIds}/shipping-address`,
          updatedAddress
        )
        .then((res) => {
          console.log(res, "cehckresponse");
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [
    contactInformation.contactPerson,
    contactInformation.contactNumber,
    selectedcustomeraddress,
  ]);
  useEffect(() => {
    const fetchPreOrderData = async () => {
      if (itemId !== undefined) {
        try {
          const response = await axios({
            url: `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/${itemId}`,
            method: "GET",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          });
          // console.log(response.data,"checkdata")
          const res = response.data;
          setShowSavedItems(true);
          // Transforming AC details
          const cutoffDate = new Date("2025-07-01T00:00:00.000Z");
          const preOrderDate = new Date(res.preOrdertimestamp);
          setIsAfterCutoff(preOrderDate >= cutoffDate);
          const transformedAcDetails = res.AcDetails.map((item) => ({
            acType: item.ac_type,
            ton: item.model.replace(/^[SC]/, ""), // Remove leading 'S' or 'C'
            plan: item.plan_year,
            quantity: item.quantity,
            subscription_plan: item.subscription_price,
            depositamount: item.deposit,
            installetionCharge: item.installation_price,
            totalSubscription: item.subscription_price * item.quantity,
            totalDeposit: item.deposit * item.quantity,
            totalInstallation: item.installation_price * item.quantity,
            priceAfter3Years: item.fixedPriceAfter3Years,
            totalAfter3Years: item.fixedPriceAfter3Years * item.quantity,
            totalAmount:
              item.subscription_price * item.quantity +
              item.deposit * item.quantity +
              item.installation_price * item.quantity,
            fixedPriceAfter3Years: item.fixedPriceAfter3Years,
            id: Date.now() + Math.floor(Math.random() * 1000), // Unique ID
          }));
          setSavedItems(transformedAcDetails);

          // Transforming materials details
          const transformedMaterials = res.materialsdetails.map((material) => ({
            materialType: material.material_name,
            quantity: Number(material.quantity),
            price: Number(material.material_price),
            totalAmount:
              Number(material.quantity) * Number(material.material_price),
          }));
          setMaterials(transformedMaterials);
          if (res.brandName === res.customer.name) {
            setIsSameBilling(true);
          }
          setBrandName(res.brandName);
          // Setting customer details
          setIsExistingCustomer(true);
          setCustomerIds(res.customer.customer_id);

          setContactInformation({
            contactNumber: res.customer_shipping_address.contactNumber,
            contactPerson: res.customer_shipping_address.contactPerson,
          });

          setAccountantInformation({
            accountantPerson: res.customer.AccountantName,
            accountantNumber: res.customer.AccountantContactNumber,
            accountantEmail: res.customer.AccountantContactEmail,
          });

          setgstin({
            name: res.customer.name,
            email: res.customer.email,
            phoneNumber: res.customer.mobile,
            billingName: res.superAdmin,
            number: res.customer_billing_address.gst_number,
          });

          // setBrandName(res.superAdmin);
          setSearchOrg(res.customer.name);

          const selectedAddress = {
            line1: res.customer_shipping_address.address_line1,
            line2: res.customer_shipping_address.address_line2,
            city: res.customer_shipping_address.city,
            state: res.customer_shipping_address.state,
            pincode: res.customer_shipping_address.pincode,
            contactNumber: res.customer_shipping_address.contactNumber,
            contactPerson: res.customer_shipping_address.contactPerson,
          };
          const billingAddressData = {
            line1: res.customer_billing_address.address_line1,
            line2: res.customer_billing_address.address_line2,
            city: res.customer_billing_address.city,
            state: res.customer_billing_address.state,
            pincode: res.customer_billing_address.pincode,
          };
          setShippingAddresses([selectedAddress]);
          setBillingAddress(billingAddressData || selectedAddress);
          handleShippingAddressSelect(selectedAddress);
          setSelectedAddressIndex(0);
          seteditmode(true);
        } catch (error) {
          console.error("Error fetching pre-order data:", error);
          // Optional: Show user-friendly error message
        }
      }
    };

    fetchPreOrderData();
  }, [itemId]);
  useEffect(() => {
    if (gstin.name.length >= 3 && bygstcustomeer === true) {
      handleCustomerIdGeneration();
    }
  }, [gstin.name]);

  useEffect(() => {
    if (searchOrg.length > 3) {
      axios
        .post(
          `${process.env.REACT_APP_MYBACKEND_PI}/api/customer/search-customer`,
          {
            input: searchOrg,
          }
        )
        .then((res) => {
          setCustomer(res.data);
        })
        .catch((err) => {
          console.error("Search error:", err);
        });
    }
  }, [searchOrg]);

  useEffect(() => {

    if (selectedOrgId !== null) {
      axios({
        method: "GET",
        url: `${process.env.REACT_APP_MYBACKEND_PI}/api/customer/getbyid/${selectedOrgId}`,
      })
        .then((res) => {
          const location =
            res.data.customer.gstin?.[0]?.address?.location || "";
          const { line1, line2 } = splitAddress(location);
          setBillingAddress({
            line1,
            line2,
            pincode: res.data.customer.gstin?.[0]?.address?.pin || "",
            city: res.data.customer.gstin?.[0]?.address?.city || "",
            state: res.data.customer.gstin?.[0]?.address?.state || "",
          });
          setgstin({
            ...gstin,
            email: res.data.customer.email,
            number: res.data.customer.gstin?.[0]?.number || "",
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [selectedOrgId]);

  function splitAddress(address) {
    if (!address || typeof address !== "string") {
      return { line1: "", line2: "" }; // Handle undefined/null/invalid input
    }

    const splitKeywords = [
      " SHOPPING CENTRE",
      " ROAD",
      " STREET",
      " AVENUE",
      " SECTOR",
      " BLOCK",
      " PHASE",
      " COLONY",
      " APARTMENT",
    ];

    for (let keyword of splitKeywords) {
      let index = address.indexOf(keyword);
      if (index !== -1) {
        return {
          line1: address.substring(0, index + keyword.length).trim(),
          line2: address.substring(index + keyword.length).trim(),
        };
      }
    }

    // Fallback: Split at the closest comma if no keyword is found
    const words = address.split(",");
    const mid = Math.floor(words.length / 2);

    return {
      line1: words.slice(0, mid).join(", ").trim() || address,
      line2: words.slice(mid).join(", ").trim() || "",
    };
  }

  const custoemeriddefine = async (name) => {
    const token = `${process.env.REACT_APP_SWIPE_TOKEN}`;
    const apiUrl = `${process.env.REACT_APP_SWIPE_BASE_URL}/api/partner/v1/customer/list`;

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `${token}`,
        },
      });
      const normalizedProvidedName = name ? name.trim().toLowerCase() : null;
      console.log(normalizedProvidedName, "checknames")
      if (normalizedProvidedName) {
        const existingCustomer = response.data.customers.find(
          (customer) =>
            customer.name.trim().toLowerCase() === normalizedProvidedName
        );
        console.log()

        return existingCustomer ? existingCustomer.customer_id : null;
      } else {
        // Return the total count of customers if no name is provided
        return response.data.total_records;
      }
    } catch (error) {
      console.error("Error fetching customer list:", error.message);
      return null;
    }
  };

  const cleanName = (name) => {
    if (!name) return "";
    return name.replace(/[^a-zA-Z0-9]/g, "").trim();
  };

  function convertToIST(date) {
    if (isNaN(date.getTime())) {
      throw new Error("Invalid date");
    }
    const istOffset = 5 * 60 + 30; // IST is UTC+5:30
    const istDate = new Date(date.getTime() + istOffset * 60 * 1000);
    return istDate;
  }

  const generateCustomerId = async (gstin) => {
    console.log(gstin)
    const existingCustomerId = await custoemeriddefine(gstin.name);
    console.log(existingCustomerId, "checkExisting")
    if (existingCustomerId) {
      // console.log("Existing customer found:", existingCustomerId);
      return existingCustomerId;
    }
    const gstCode = "27";
    const currentDate = moment().format("DDMMYYHHmmssSSS");
    const name = cleanName(gstin.name);
    const data1 = await custoemeriddefine(); // Get the total customer count
    console.log(data1, "checkdata1")
    const nextCustomerNumber =
      data1 !== null ? (data1 + 1).toString().padStart(4, "0") : "0001";
    const newCustomerId = `CL${name
      .substring(0, 3)
      .toUpperCase()}${currentDate}${gstCode}${nextCustomerNumber}`;
    return newCustomerId;
  };
  const handleCustomerIdGeneration = async () => {
    try {
      const generatedCustomerId = await generateCustomerId(gstin);
      if (generatedCustomerId?.startsWith("CL")) {
        setCustomerIds(generatedCustomerId);
      }
    } catch (error) {
      // alert("Error generating customerId:", error.message);
      console.error(gstin, "checalerafter");
    }
  };
  const handleBlurget = () => {
    if (gstin.name && gstin.name.length >= 3) {
      handleCustomerIdGeneration();
    }
  };

  const handleCopyToShipping = (billingData) => {
    setCopiedShippingAddress(billingData);
  };
  const handleTransformedAddress = (address) => {
    setTransformedAddress(address);
  };
  const handleACDetailsChange = (newDetails) => {
    setACDetails((prevDetails) => ({ ...prevDetails, ...newDetails }));
  };
  const handleCustomerData = (data) => {
    setCustomerData(data);
  };

  const handleOrgSelect = (orgId, orgData) => {
    setSelectedOrgId(orgId);
    setSelectedOrgData(orgData);
  };
  const handleClearSearch = () => {
    setSelectedOrgId(null);
    setSelectedOrgData(null);
    setSelectedShippingAddress(null);
  };

  const handleShippingAddressSelect = (address) => {
    const addressRegex = /^[a-zA-Z0-9\s!@#$%^&*()\-_+=~.,;'’:<>?/]+$/;

    // Clean and normalise the inputs
    const line1 = address?.line1 ? address.line1.replace(/\s+/g, ' ').trim() : '';
    const line2 = address?.line2 ? address.line2.replace(/\s+/g, ' ').trim() : '';

    // Validation
    if (!line1 || !line2) {
      alert("Both address lines are required.");
      return;
    }

    if (!addressRegex.test(line1) || !addressRegex.test(line2)) {
      alert("Address lines contain invalid characters.");
      return;
    }

    // ✅ If all validations pass
    setselectedcustomeraddress({ ...address, line1, line2 });
    setSelectedShippingAddress({ ...address, line1, line2 });
  };


  const backendcustomercreation = async () => {
    const formattedAddress = {
      location: `${billingAddress.line1}, ${billingAddress.line2}`, // Combine line1 and line2
      city: billingAddress.city,
      state: billingAddress.state,
      pin: billingAddress.pincode, // Pin becomes the pincode
    };
    const data = {
      name: gstin.name,
      customer_id: CustomerIds,
      userid: null,
      superadminphone: gstin.phoneNumber,
      superadminname: gstin.billingName,
      email: gstin.email,
      brandName: brandName,
      gstin: {
        number: gstin.number,
        billingName: gstin.name,
        address: formattedAddress,
      },
      shipping_address: selectedcustomeraddress,
      AccountantName: accountantInformation.accountantPerson,
      AccountantContactNumber: accountantInformation.accountantNumber,
      AccountantContactEmail: accountantInformation.accountantEmail,
    };
    try {
      const response = await axios({
        url: `${process.env.REACT_APP_MYBACKEND_PI}/api/customer/save`,
        method: "POST",
        data: data,
      });

      try {
        const shippingAddresses = response.data.customer.shipping_address;
        if (shippingAddresses && shippingAddresses.length > 0) {
          const lastAddressId =
            shippingAddresses[shippingAddresses.length - 1]._id;
          return lastAddressId;
        } else {
          alert("No shipping addresses found.");
          return;
        }
      } catch (secondApiError) {
        alert(
          "Error in handling shipping address response: " +
          secondApiError.message
        );
        return;
      }
    } catch (firstApiError) {
      alert("Error in first API call: " + firstApiError.message);
      return;
    }
  };

  const createInstallationItem = (type, quantity, charge, itemId) => {
    if (quantity > 0 && charge > 0) {
      // Check if charge is also valid
      const unitPrice = charge / 1.18; // This assumes 18% tax

      return {
        id: itemId,
        name: `Installation (${type} AC)`,
        quantity: quantity,
        unit_price: unitPrice,
        tax_rate: 18,
        price_with_tax: charge,
        item_type: "Service",
        net_amount: unitPrice * quantity,
        total_amount: charge * quantity,
      };
    }
    return null; // Return null if quantity or charge is invalid
  };
  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const mapProduct = (acModel, item) => {
    const models = {
      10: {
        id: "mlmc_3y_1t_p",
        name: "Monthly Leasing and Maintenance charges of Air Conditioner - 1T",
        unitPrice: 1014.84,
        priceWithTax: 1299,
      },
      15: {
        id: "mlmc_3y_1.5t_p",
        name: "Monthly Leasing and Maintenance charges of Air Conditioner - 1.5T",
        unitPrice: 1092.97,
        priceWithTax: 1399,
      },
      20: {
        id: "mlmc_3y_2t_p", // Default for Split
        name: "Monthly Leasing and Maintenance charges of Air Conditioner - 2T",
        unitPrice: 1327.34,
        priceWithTax: 1699,
      },
      30: {
        id: "mlcmc_2y_3t_p",
        name: "Monthly Leasing and Maintenance charges of Air Conditioner - 2Y 30T",
      },
    };
    if (item.acType === "Cassette") {
      models["20"] = {
        id: "mlmc_cassette_5y_2t_p",
        name: "Monthly Leasing and Maintenance charges of Air Conditioner - 5Y 2T-Cassete",
        unitPrice: 1952.34,
        priceWithTax: 2499,
      };
      models["30"] = {
        id: "mlmc_cassette_5y_3t_p",
        name: "Monthly Leasing and Maintenance charges of Air Conditioner - 5Y 3T-Cassete",
        unitPrice: 2342.96,
        priceWithTax: 2999,
      };
    }
    const model = models[acModel];

    if (!model) {
      throw new Error("Invalid acModel provided.");
    }

    const baseQuantity = item.quantity;
    const isMonthlyLeasing =
      model.id?.startsWith("mlmc_") ||
      model.name?.toLowerCase().includes("monthly leasing");
    // const adjustedQuantity =
    //   take3MonthPayment && isMonthlyLeasing ? baseQuantity * 3 : baseQuantity;
    // const adjustedtotalSubscription =
    //   take3MonthPayment && isMonthlyLeasing
    //     ? item.totalSubscription * 3
    //     : item.totalSubscription;
    // let priceWithTax = Number(adjustedtotalSubscription / adjustedQuantity);
    // let unitPrice = adjustedtotalSubscription / adjustedQuantity / 1.28;
    const adjustedQuantity =
      take3MonthPayment && isMonthlyLeasing ? baseQuantity * 3 : baseQuantity;
    const adjustedtotalSubscription =
      take3MonthPayment && isMonthlyLeasing
        ? item.subscription_plan * 3 * baseQuantity
        : item.subscription_plan * baseQuantity;
    const priceWithTax = Number(adjustedtotalSubscription / adjustedQuantity);
    const unitPrice = priceWithTax / 1.18;
    return {
      id: model.id,
      name: model.name,
      quantity: adjustedQuantity,
      unit_price: unitPrice,
      tax_rate: 18,
      price_with_tax: priceWithTax,
      item_type: "Service",
      net_amount: unitPrice * adjustedQuantity,
      total_amount: adjustedtotalSubscription,
    };
  };

  const mapMaterial = (items) => {
    const materials = apiMaterials.reduce((acc, material) => {
      acc[material.material_code] = {
        id: material.material_code,
        name: material.material_name,
        unit_price: material.unit_price,
        price_with_tax: material.price_with_tax,
      };
      return acc;
    }, {});

    // Check if items is an array
    if (!Array.isArray(items)) {
      alert("Expected an array but got:", items);
      return []; // Return an empty array instead of null
    }

    // Map over the provided items and dynamically build the material objects
    return items
      .map((item) => {
        const material =
          materials[item.materialType.toLowerCase().replace(/\s+/g, "_")];
        if (!material) {
          alert("Material type not found for:", item.materialType);
          return null; // If no matching material is found, return null
        }

        // Ensure quantity and price are numbers
        const quantity = Number(item.quantity);
        let priceWithTax = Number(item.totalAmount / quantity);
        let unitPrice = priceWithTax / 1.18;
        return {
          id: material.id,
          name: material.name,
          quantity: quantity, // Correctly formatted quantity
          unit_price: unitPrice, // Static unit price from materials
          tax_rate: 18, // Static tax rate
          price_with_tax: priceWithTax, // Total amount from input
          item_type: "Product", // Static type 'Material'
          net_amount: unitPrice * quantity, // Net amount excluding tax
          total_amount: item.totalAmount, // Total amount with tax
        };
      })
      .filter((item) => item !== null); // Filter out any null values if materials are not found
  };
  const mapRefundableDeposit = (
    acModel,
    ton,
    duration,
    quantity,
    totalAmount
  ) => {
    const refundableDeposits = {
      Split: {
        "3year": {
          10: {
            id: "refund_3y_1t_p",
            name: "Refundable Deposit - 1T",
          },
          15: {
            id: "refund_3y_1.5t_p",
            name: "Refundable Deposit - 1.5T",
          },
          20: {
            id: "refund_3y_2t_p",
            name: "Refundable Deposit - 2T",
          },
        },
        "3+3year": {
          10: {
            id: "refund_3y_1t_p",
            name: "Refundable Deposit - 1T",
          },
          15: {
            id: "refund_3y_1.5t_p",
            name: "Refundable Deposit - 1.5T",
          },
          20: {
            id: "refund_3y_2t_p",
            name: "Refundable Deposit - 2T",
          },
        },
        "5years": {
          10: {
            id: "refund_5y_1t_p",
            name: "Refundable Deposit - 1T",
          },
          15: {
            id: "refund_5y_1.5t_p",
            name: "Refundable Deposit - 1.5T",
          },
          20: {
            id: "refund_5y_2t_p",
            name: "Refundable Deposit - 2T",
          },
        },
      },
      Cassette: {
        20: {
          id: "refund_cassette_2t_p",
          name: "Refundable Deposit - Cassette 2 Ton",
        },
        30: {
          id: "refund_cassette_3t_p",
          name: "Refundable Deposit - Cassette 3 Ton",
        },
      },
    };

    // Check for valid AC model
    if (!refundableDeposits[acModel]) {
      alert(`Invalid AC model provided: ${acModel}`);
      return null;
    }

    let deposit;
    if (acModel === "Split") {
      // Check for valid duration
      if (!refundableDeposits[acModel][duration]) {
        alert(`Invalid duration provided for Split AC: ${duration}`);
        return null;
      }
      // Check for valid tonnage
      deposit = refundableDeposits[acModel][duration][ton];
      if (!deposit) {
        alert(
          `Invalid tonnage provided for duration ${duration} in Split AC model: ${ton}`
        );
        return null;
      }
    } else if (acModel === "Cassette") {
      // Check for valid tonnage
      deposit = refundableDeposits[acModel][ton];
      if (!deposit) {
        alert(`Invalid tonnage provided for Cassette AC model: ${ton}`);
        return null;
      }
    }

    // Calculate unit price and price with tax dynamically

    let priceWithTax = Number(totalAmount / quantity);
    let unitPrice = priceWithTax;

    return {
      id: deposit.id,
      name: deposit.name,
      quantity: Number(quantity),
      unit_price: parseInt(unitPrice.toFixed(2)),
      tax_rate: 0,
      price_with_tax: parseInt(priceWithTax.toFixed(2)),
      item_type: "Service",
      net_amount: unitPrice * quantity,
      total_amount: totalAmount,
    };
  };

  const uploadPdfToS3 = async (pdfBlob, fileName) => {
    try {
      // Convert blob → Base64
      const base64Data = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(pdfBlob);
        reader.onloadend = () => {
          const base64String = reader.result.split(",")[1]; // remove prefix
          resolve(base64String);
        };
        reader.onerror = (err) => reject(err);
      });

      const fileKey = `invoices/${fileName}`;

      const response = await fetch(`${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/upload-file`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          file: base64Data,
          mimetype: "application/pdf",
          fileKey
        }),
      });

      const result = await response.json();

      if (!result.success) {
        throw new Error(result.message || "Upload failed");
      }

      return result.data.fileUrl; // ✅ S3 file URL
    } catch (error) {
      console.error("Error uploading PDF:", error);
      throw new Error("Failed to upload PDF");
    }
  };

  const updateurl = async (pdfurl, preOrderid) => {
    try {
      const res = await axios.patch(
        `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/addpilinkurl`,
        {
          preOrderid: preOrderid,
          pilink: pdfurl,
        }
      );
      // console.log(res.data);
      setIsLoading(false);
      navigate("/home");
    } catch (err) {
      console.error("Error:", err);
    }
  };

  const createPIInvoice = async (
    savedItems,
    materials,
    customerdata,
    selectedShippingAddress,
    billingAddress,
    splitInstallationCharge,
    cassetteInstallationCharge,
    itemId
  ) => {
    const currentDate = formatDate(new Date());
    const futureDate = formatDate(
      new Date(new Date().setFullYear(new Date().getFullYear() + 3))
    );

    // Mapping items for the invoice
    const invoiceItems = savedItems.map((item) => {
      return mapProduct(item.ton, item);
    });
    // Filter and calculate quantities for installation items
    const splitItems = savedItems.filter((item) => item.acType === "Split");
    const cassetteItems = savedItems.filter(
      (item) => item.acType === "Cassette"
    );

    const totalSplitQuantity = splitItems.reduce(
      (sum, item) => sum + item.quantity,
      0
    );
    const totalCassetteQuantity = cassetteItems.reduce(
      (sum, item) => sum + item.quantity,
      0
    );

    // Add installation items if applicable
    const splitInstallationItem = createInstallationItem(
      "Split",
      totalSplitQuantity,
      splitInstallationCharge,
      "install_1500_p"
    );
    const cassetteInstallationItem = createInstallationItem(
      "Cassette",
      totalCassetteQuantity,
      cassetteInstallationCharge,
      "install_cassette_p"
    );

    if (splitInstallationItem) {
      invoiceItems.push(splitInstallationItem);
    }
    if (cassetteInstallationItem) {
      invoiceItems.push(cassetteInstallationItem);
    }

    savedItems.forEach((item) => {
      const acModel = item.acType === "Cassette" ? "Cassette" : "Split";
      let duration = null;
      if (acModel === "Split") {
        duration = item.plan === "3+2year" ? "5years" : item.plan || "5years";
      }
      const refundableItem = mapRefundableDeposit(
        acModel,
        item.ton,
        duration,
        item.quantity,
        item.totalDeposit
      );
      refundableItem.total_amount = item.depositamount * item.quantity;
      invoiceItems.push(refundableItem);
    });

    const materialItems = mapMaterial(materials);
    materialItems.forEach((material) => {
      if (material) {
        invoiceItems.push(material);
      }
    });

    // Invoice details
    const invoice = {
      document_type: "pro_forma_invoice",
      document_date: currentDate,
      party: {
        id: customerdata.customer_id,
        type: "customer",
        name: customerdata.name,
        email: customerdata.email,
        ...(billingAddress.gst_number && { gstin: billingAddress.gst_number }),
        phone_number: customerdata.mobile,
        country_code: "91",
        shipping_address: {
          addr_id_v2: selectedShippingAddress.addressid || "1",
          address_line1: selectedShippingAddress.address_line1,
          address_line2: selectedShippingAddress.address_line2,
          pincode: selectedShippingAddress.pincode,
          city: selectedShippingAddress.city,
          country: "India",
          state: selectedShippingAddress.state,
        },
        billing_address: {
          addr_id_v2: "1",
          address_line1: billingAddress.address_line1,
          address_line2: billingAddress.address_line2,
          pincode: billingAddress.pincode,
          city: billingAddress.city,
          country: "India",
          state: billingAddress.state,
        },
      },

      items: invoiceItems,

      notes: `Start Date : ${currentDate} End Date: ${futureDate}`,
      round_off: true,
      bank_details: {
        account_number: "10217543754",
        ifsc: "IDFB0040101",
        bank_name: "IDFC FIRST Bank",
        branch: "BKC NAMAN CHAMBERS BRANCH",
      },
    };

    try {
      const token = `${process.env.REACT_APP_SWIPE_TOKEN}`;

      // API call to create the invoice
      const swipeResponse = await axios.post(
        `${process.env.REACT_APP_SWIPE_BASE_URL}/api/partner/v2/doc`,
        invoice,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      const hashId = swipeResponse.data.data.hash_id;

      // API call to get the PDF
      const pdfResponse = await axios.get(
        `${process.env.REACT_APP_SWIPE_BASE_URL}/api/partner/v2/doc/pdf/${hashId}`,
        {
          headers: {
            Authorization: token,
          },
          responseType: "arraybuffer",
        }
      );

      const pdfBlob = new Blob([pdfResponse.data], { type: "application/pdf" });
      const fileName = `invoice_${hashId}.pdf`;
      const pdfurl = await uploadPdfToS3(pdfBlob, fileName);
      updateurl(pdfurl, itemId);
    } catch (error) {
      setIsLoading(false);
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "An error occurred during invoice creation.";
      const validationErrors = error?.response?.data?.errors;

      if (validationErrors) {
        // Loop through each error and display it dynamically
        let errorAlert = "";
        Object.keys(validationErrors).forEach((field) => {
          if (field.includes("state")) {
            // Custom message for state field errors
            errorAlert += `Issue with State Name in ${field}: Please select a valid state.\n`;
          } else {
            // Default message for other fields
            errorAlert += `${field}: ${validationErrors[field]}\n`;
          }
        });

        // Display all errors in one alert box
        alert(`Validation Errors:\n${errorAlert}`);
      } else {
        alert(`Error: ${errorMessage}`);
      }
    }
  };

  const validatePreOrderData = () => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!CustomerIds) {
      alert("⚠️ Customer ID is missing. Please check and try again.");
      return false;
    }
    if (!gstin || !gstin.name || !gstin.email || !gstin.phoneNumber) {
      alert(
        "⚠️ Customer information is incomplete. Please provide the name, email, and phone number. 📧📞"
      );
      return false;
    }
    if (!gstin.billingName) {
      alert(
        "⚠️ Superadmin name is pending. 🕵️‍♂️ Please update it before proceeding."
      );
      return false;
    }
    if (!brandName) {
      alert("⚠️ Brand name is missing. 🏷️ Please add the brand name.");
      return false;
    }
    if (
      !selectedShippingAddress ||
      !selectedShippingAddress.line1 ||
      !selectedShippingAddress.city ||
      !selectedShippingAddress.state ||
      !selectedShippingAddress.pincode
    ) {
      alert(
        "⚠️ Shipping address is incomplete. 🚚 Please provide address line, city, state, and pincode."
      );
      return false;
    }
    if (
      !contactInformation ||
      !contactInformation.contactPerson ||
      !contactInformation.contactNumber
    ) {
      alert(
        "⚠️ Contact information is incomplete. 📇 Please provide the contact person and number."
      );
      return false;
    }
    if (!emailRegex.test(gstin.email)) {
      alert("⚠️ Invalid email format. Please enter a valid email.");
      return false;
    }

    // Ensure that at least one of materials or savedItems is not empty
    if (
      (!materials || !Array.isArray(materials) || materials.length === 0) &&
      (!savedItems || !Array.isArray(savedItems) || savedItems.length === 0)
    ) {
      alert(
        "⚠️ Either Materials or Saved Items must have at least one entry. Both cannot be empty. 🚫"
      );
      return false;
    }

    return true;
  };
  const savesiteSurveyDetails = async () => {
    setIsLoading(true);
    if (!validatePreOrderData()) {
      setIsLoading(false);
      return;
    }

    try {
      const addressid = await backendcustomercreation();

      const totalOverallQuantity = savedItems.reduce(
        (sum, item) => sum + Number(item.quantity || 0),
        0
      );

      savedItems = savedItems.map((item) => {
        // if (item.acType === "Split") {
        const ton = Number(item.ton);
        const plan = item.plan;
        let config;
        console.log({ type: item.acType })
        if (item.acType === "Split") {
          config = state === "Delhi"
            ? ACpricingConfigDelhi?.Split?.[ton]?.[plan]
            : ACpricingConfig?.Split?.[ton]?.[plan]
        } else {
          config = state === "Delhi"
            ? ACpricingConfigDelhi?.Cassette?.[ton]?.[plan]
            : ACpricingConfig?.Cassette?.[ton]?.[plan]
        }

        if (config) {
          const useFlatPrice = totalOverallQuantity <= 3;
          let depositRate;
          if (isEditableUser) {
            depositRate = Number(item.depositamount);
          } else {
            depositRate =
              itemId !== undefined
                ? item.depositamount
                : config.depositamount;
          }

          const installationRate =
            itemId !== undefined
              ? item.installetionCharge
              : useFlatPrice
                ? (config.installetionCharge + config.addOn)
                : config.installetionCharge;

          const updatedDeposit = depositRate * item.quantity;
          const updatedInstallation = installationRate * item.quantity;

          const updatedTotalAmount =
            updatedDeposit +
            updatedInstallation +
            (item.totalSubscription || 0);

          return {
            ...item,
            depositamount: depositRate,
            installetionCharge: installationRate,
            totalDeposit: updatedDeposit,
            totalInstallation: updatedInstallation,
            totalAmount: updatedTotalAmount,
          };
        }
      });

      const formattedAddress = {
        location: `${billingAddress.line1}, ${billingAddress.line2}`, // Combine line1 and line2
        city: billingAddress.city,
        state: billingAddress.state,
        pin: billingAddress.pincode, // Pin becomes the pincode
      };
      savedItems = savedItems.map((item) => {
        const baseTotal =
          (item.totalDeposit || 0) + (item.totalInstallation || 0);

        const threeMonthAdvance = take3MonthPayment
          ? (item.totalSubscription || 0) * 3
          : item.totalSubscription || 0;

        return {
          ...item,
          totalAmount: baseTotal + threeMonthAdvance,
        };
      });

      const preOrderData = {
        customer: {
          customer_id: CustomerIds,
          name: gstin.name,
          email: gstin.email.trim(),
          mobile: gstin.phoneNumber.trim(),
        },
        superAdmin: gstin.billingName,
        brandName: brandName,
        AcDetails: savedItems.map((item) => ({
          ac_type: item.acType,
          model:
            item.acType === "Split"
              ? `S${item.ton}`
              : item.acType === "Cassette"
                ? `C${item.ton}`
                : null,
          plan_year: item.plan,
          subscription_price: item.subscription_plan,
          fixedPriceAfter3Years: item.priceAfter3Years,
          deposit: item.depositamount,
          installation_price: item.installetionCharge,
          quantity: item.quantity,
        })),
        take3MonthPayment,
        Ac_totalAmount: savedItems.reduce(
          (sum, item) => sum + item.totalAmount,
          0
        ),
        materialsdetails: materials.map((item) => ({
          material_name: item.materialType,
          material_price: item.price,
          quantity: item.quantity,
        })),
        material_totalAmount: materials.reduce(
          (sum, item) => sum + item.totalAmount,
          0
        ),
        // pending_amount: savedItems.reduce((sum, item) => sum + item.totalAmount, 0)+ materials.reduce((sum, item) => sum + item.totalAmount, 0),

        customer_shipping_address: {
          address_line1: selectedShippingAddress.line1,
          address_line2: selectedShippingAddress.line2,
          pincode: String(selectedShippingAddress.pincode),
          city: selectedShippingAddress.city,
          country: "India",
          state: selectedShippingAddress.state.trim().toUpperCase(), // Remove extra spaces before converting to uppercase
          addressid: addressid,
          contactPerson: contactInformation.contactPerson,
          contactNumber: contactInformation.contactNumber,
        },
        customer_billing_address: {
          ...(gstin.number && { gst_number: gstin.number }),
          address_line1: billingAddress.line1,
          address_line2: billingAddress.line2,
          pincode: String(billingAddress.pincode),
          city: billingAddress.city,
          country: "India",
          state: billingAddress.state.trim().toUpperCase(), // Remove extra spaces before converting to uppercase
        },
        preOrdertimestamp: convertToIST(new Date()),
      };
      let cassetteInstallationCharge = null;
      let splitInstallationCharge = null;

      preOrderData.AcDetails.forEach((item) => {
        if (
          cassetteInstallationCharge === null &&
          item.ac_type.toLowerCase() === "cassette"
        ) {
          cassetteInstallationCharge = item.installation_price;
        }
        if (
          splitInstallationCharge === null &&
          item.ac_type.toLowerCase() === "split"
        ) {
          splitInstallationCharge = item.installation_price;
        }
      });

      if (itemId !== undefined) {
        const preOrderResponse = await axios.put(
          `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/${itemId}/updatedetails`,
          preOrderData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          }
        );
        createPIInvoice(
          savedItems,
          materials,
          preOrderData.customer,
          preOrderData.customer_shipping_address,
          preOrderData.customer_billing_address,
          splitInstallationCharge,
          cassetteInstallationCharge,
          itemId
        );
      } else {
        const preOrderResponse = await axios.post(
          `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder`,
          preOrderData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          }
        );

        createPIInvoice(
          savedItems,
          materials,
          preOrderData.customer,
          preOrderData.customer_shipping_address,
          preOrderData.customer_billing_address,
          splitInstallationCharge,
          cassetteInstallationCharge,
          preOrderResponse.data._id
        );
        setSavedItems([]);
        setMaterials([]);
      }
    } catch (error) {
      console.error("Error saving pre-order details:", error);
      alert(
        "An error occurred while saving pre-order details. Please try again."
      );
      setIsLoading(false);
    }
  };

  return (
    <div className="space-y-6 p-6 bg-secondary min-h-screen justify-start block">
      <h1 className="text-2xl font-bold">Order Details</h1>
      <ACdetails
        setShowSavedItems={setShowSavedItems}
        showSavedItems={showSavedItems}
        onACDetailsChange={handleACDetailsChange}
        acDetails={acDetails}
        setACDetails={setACDetails}
        savedItems={savedItems}
        setSavedItems={setSavedItems}
        take3MonthPayment={take3MonthPayment}
        setTake3MonthPayment={setTake3MonthPayment}
      />
      <Extramaterial
        currentMaterial={currentMaterial}
        materials={materials}
        setCurrentMaterial={setCurrentMaterial}
        setMaterials={setMaterials}
        apiMaterials={apiMaterials}
      />
      <OrgDetails
        customer={customer}
        onOrgSelect={handleOrgSelect}
        onClearSearch={handleClearSearch}
        onCopyToShipping={handleCopyToShipping}
        onTransformedAddress={handleTransformedAddress}
        gstin={gstin}
        setgstin={setgstin}
        isChecked={isChecked}
        SetisChecked={SetisChecked}
        billingAddress={billingAddress}
        setBillingAddress={setBillingAddress}
        setIsExistingCustomer={setIsExistingCustomer}
        isExistingCustomer={isExistingCustomer}
        setCustomerIds={setCustomerIds}
        setchecksuperadmin={setchecksuperadmin}
        ischecksuperadmin={ischecksuperadmin}
        contactInformation={contactInformation}
        setContactInformation={setContactInformation}
        handleBlurget={handleBlurget}
        handleCustomerIdGeneration={handleCustomerIdGeneration}
        setBrandName={setBrandName}
        brandName={brandName}
        setIsSameBilling={setIsSameBilling}
        isSameAsBilling={isSameAsBilling}
        searchOrg={searchOrg}
        setSearchOrg={setSearchOrg}
        setShippingAddresses={setShippingAddresses}
        editmode={editmode}
        seteditmode={seteditmode}
        setbygstcustomer={setbygstcustomer}
        accountantInformation={accountantInformation}
        setAccountantInformation={setAccountantInformation}
        showRadioButton={isExisting}
      />
      <ShippingAddressFile
        selectedOrgId={selectedOrgId}
        onSelectAddress={handleShippingAddressSelect}
        onCustomerData={handleCustomerData}
        shippingAddress={shippingAddress}
        setShippingAddress={setShippingAddress}
        onTransformedAddress={handleTransformedAddress}
        copiedShippingAddress={copiedShippingAddress}
        setShippingAddressorder={setShippingAddressorder}
        shippingaddressorder={shippingaddressorder}
        setShippingAddresses={setShippingAddresses}
        shippingAddresses={shippingAddresses}
        contactInformation={contactInformation}
        setSelectedAddressIndex={setSelectedAddressIndex}
        selectedAddressIndex={selectedAddressIndex}
      />
      <ShippingAddressGuid
        contactInformation={contactInformation}
        setContactInformation={setContactInformation}
      />
      <Acountant
        accountantInformation={accountantInformation}
        setAccountantInformation={setAccountantInformation}
      />

      {/* <SitesSurvery   siteSurvey={siteSurvey} setSiteSurvey={setSiteSurvey}/> */}
      <div className="space-x-4 p-4">
        {isLoading && (
          <div className="fixed inset-0 bg-gray-50 bg-opacity-70 overflow-y-auto h-full w-full flex items-center justify-center">
            <LoadingAnimation />
          </div>
        )}
        {itemId !== undefined ? (
          <button
            className="bg-white text-primary py-2 px-4 border border-primary m-1 md:m-0"
            onClick={savesiteSurveyDetails}
          >
            {" "}
            Update Details
          </button>
        ) : (
          <button
            className="bg-white text-primary py-2 px-4 border border-primary m-1 md:m-0"
            onClick={savesiteSurveyDetails}
          >
            {" "}
            Save Details
          </button>
        )}
      </div>
    </div>
  );
};

export default OrderForm;
